import { Pipe, PipeTransform } from '@angular/core';
import { SafeUrl } from '@angular/platform-browser';

@Pipe({
  name: 'assetSource',
})
export class AssetSourcePipe implements PipeTransform {
  public transform(uuid?: string, localUrl?: SafeUrl): SafeUrl {
    return localUrl != null ? localUrl : `/api/assets/${uuid}`;
  }
}
